import { subscriberIdApi } from '../../store';
import { formatSubscriberIdApiUrl } from '../../utils/formatApiUrl';
import { dcRulesActiveMapping, dcRulesListMapping } from './mapping';
import { IDcRule } from './types';

export const dcRulesApi = subscriberIdApi.injectEndpoints({
    endpoints: (builder) => ({
        getDcRules: builder.query<IDcRule, { subscriberId: string }>({
            async queryFn(arg, _queryApi, _extraOptions, baseQuery) {
                const responseList = await baseQuery(formatSubscriberIdApiUrl(arg.subscriberId, 'dcrules/list'));

                if (responseList.error) throw responseList.error;

                const list = dcRulesListMapping(responseList.data);
                const activeRuleId = list.find(rule => rule.isActive)?.id;

                let activeRule;
                if (activeRuleId) {
                    const activeRuleResponse =
                        await baseQuery(formatSubscriberIdApiUrl(arg.subscriberId, `dcrules/${activeRuleId}`));

                    if (activeRuleResponse.error) throw activeRuleResponse.error;

                    activeRule = dcRulesActiveMapping(activeRuleResponse.data);
                }

                return {
                    data: {
                        list,
                        hasActiveRule: activeRuleId !== undefined,
                        activeRule,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetDcRulesQuery,
} = dcRulesApi;
